const NS = 'ResourcesPage';
const CLS = 'resourcesPage';
const CLS_HIDE = 'd-none';
const CLS_MB_ACTIVE = 'is-mbActive';

import Handlebars from 'handlebars';

import { ResourcesItemWidget } from '../../../widgets/resourcesItemWidget/js/resourcesItemWidget';
import { SearchFilterCheckboxWidget } from '../../../widgets/searchFilterCheckboxWidget/js/searchFilterCheckboxWidget';
import { utils } from '../../../../global/js/utils';
import { mediaQuery } from '../../../../global/js/wlc/mediaQuery';
import { spinnerService } from '../../../../global/js/wlc/spinnerService';

export class ResourcesPage {
	constructor(element) {
		this.element = element;
		this.$element = $(element);

		this.$topbar = this.$element.find(`.searchFilterTopBarWidget`);
		this.$fltBtnMb = this.$element.find(`.searchFilterTopBarWidget-fltBtnMb`);
		this.$filterTagBtns = this.$element.find(`.searchFilterTopBarWidget-tag-btn`);
		this.$fltBtnCloseMb = this.$element.find(`.searchFilterTopBarWidget-fltBtnCloseMb`);
		this.$searchInp = this.$element.find(`.searchFilterTopBarWidget-resourcesPageSearch`);
		this.$sidebar = this.$element.find(`.searchFilterSidebarWidget`);
		this.$filterTitlesList = this.$element.find(`.searchFilterSidebarWidget-filter-titles-btn`);
		this.$fltApplyBtnMb = this.$sidebar.find(`.searchFilterSidebarWidget-fltApplyBtnMb`);
		this.$fltResetBtnMb = this.$sidebar.find(`.searchFilterSidebarWidget-fltResetBtnMb`);
		this.$filterItemsList = this.$element.find(`.searchFilterSidebarWidget-filter-item`);
		this.$typeSlickSlides = this.$element.find(`.resourcesTypeCarouselBlock .slick-slide .programCardBlock-card`);
		this.$carouselBlock = this.$element.find(`.resourcesCustomCarouselBlock`);
		this.$checkboxes = this.$element.find(`input[type="checkbox"]`);
		this.$itemsTitle = this.$element.find(`.${CLS}-itemsTitle`);
		this.$backBtn = this.$element.find(`.${CLS}-back-btn`);
		this.$resultsHtml = this.$element.find(`.${CLS}-results`);
		this.$noResultsHtml = this.$element.find(`.${CLS}-noResults`);
		this.$resourcesPagePagination =  this.$element.find(`.resourcesPage-pagination`);
		
		this.spinnerService = spinnerService;
		this.pageId = this.$element.data('pageId');
		this.pageSize = this.$element.data('pageSize');
		this.getApi = this.$element.data('getItemsApi');
		this.getProgramDetailsApi = this.$element.data('getProgramDetailsApi');
		this.getFilterCategory = this.$element.find(`.resourcesCustomCarouselBlock`).data('filterCategory');
		this.$paginationInfo = this.$element.find(`.pagination-info`);
		this.$paginationLoadMore = this.$element.find(`.pagination-load-more`);
		
		this.$checkboxes.on('change', () => {
			if(this.params.typeName){
				delete this.params["typeName"];
				delete this.params["ResourceTypes"];
				this.$itemsTitle.html();
			}
		});

		var url = new URL(window.location.href);
		if(url.searchParams.get("ResourceTypes") === undefined){
			this.$urlResourceTypes = '';
		}
		else{
			this.$urlResourceTypes = url.searchParams.get("ResourceTypes");
		}
		this.$urlaudience = url.searchParams.get("Audience");
		this.$urlsubject = url.searchParams.get("Subject");
		this.$urltypeName = url.searchParams.get("typeName");
		this.initParams();
		this.initCheckbox();
		/* hidden for now */
		//this.setCarouselParam();
		this.handleSearchInput();
		this.handleFilterBtnMb();
		this.handleFilterTitleTagBtns();
		this.setItemTemplate();
		this.getItems();

		this.$paginationLoadMore.on('click', () => {
			this.params.pageNumber++;
			this.getItems(true);
		});
		
	}

	initParams() {
		var url = new URL(window.location.href);
		this.params = {
			pageId: this.pageId,
			pageNumber: 1,
			pageSize: this.pageSize,
			ResourceTypes: this.$urlResourceTypes || '',
			Audience: this.$urlaudience || '',
			Subject: this.$urlsubject || '',
			typeName: this.$urltypeName || '',
		};
	}

	// Get items (reload content)
	getItems(isLoadMore = false) {
		// URL Params
		let url = this.getApi;
		if(!_.isEmpty(this.params)) {
			url += `?${$.param(this.params)}`;
		}

		if (!isLoadMore) {
			this.$resultsHtml.empty();
		}

		// Display spinner
		this.spinnerService.appendTo();
		this.updateUrl();

		if(this.params.typeName){
			this.$itemsTitle.html(this.params.typeName);
			window.location.href="#resourcesPage-itemsTitle";
			this.urlParam = new URLSearchParams(window.location.search);
			$('.searchFilterTopBarWidget-tag-btn').each((index, element) => {
				if($(element).data("filterKey") === this.getFilterCategory){
					$(element).removeClass('is-mbActive');
					if($(element).html().toLowerCase() === this.urlParam.get('typeName').toLowerCase()){
						$(element).addClass('is-mbActive');
					}
				}
			});
			$('.' + this.getFilterCategory + ' input[type="checkbox"]').each((index, element) => {
				if($(element).val()===this.urlParam.get(this.getFilterCategory)){
					$(element).prop('checked', true);
				}
				else{
					$(element).prop('checked', false);
				}
			});
		}

		const urlParams = new URLSearchParams(window.location.search);
        if(urlParams.get('Audience')!=="" || urlParams.get('Subject')!=="" || urlParams.get('ResourceTypes')!=="" ){
            $(".resourcesCustomCarouselBlock").css("display","none");
            $(".resultsSection").css("display","block");
        }
        else{
            $(".resourcesCustomCarouselBlock").css("display","block");
            $(".resultsSection").css("display","none");
        }

		// Fetch data
		$.ajax({
			type: 'GET',
			url: url,
			success: (data) => {
				if(data.totalCount == 0 || data.totalCount === "0"){
					this.$resourcesPagePagination.css('display', 'none');
				}
				let items = data.results;
				
				// Loop over results
				if(items.length > 0) {
					this.$noResultsHtml.hide();
					items.forEach((item) => {
						let itemMarkup = this.itemTemplate(item);
						this.$resultsHtml.append(`
							${itemMarkup}
						`);
		
						new ResourcesItemWidget(this.$resultsHtml.find('.resourcesItemWidget').last()[0]);
					});
					if(data.totalCount > 0){
						this.updatePaginationInfo(items.length, data.totalCount);
					}
					if (items.length < this.params.pageSize) {			
						this.$paginationLoadMore.hide();
					} else {
						this.$paginationLoadMore.show();
					}
				}
				else {
					// No results
					this.$noResultsHtml.show();
				}

				// Remove spinner
				this.spinnerService.removeFrom();
			}
		});
	}

	updatePaginationInfo(currentResultsCount, totalResultsCount) {		
		const totalShownResults = ((this.params.pageNumber-1) * this.params.pageSize) + currentResultsCount;
		this.$paginationInfo.html(`${totalShownResults} out of ${totalResultsCount} are showing`)
	}

	setItemTemplate() {
		let mediaItemPartial = require('../../../widgets/resourcesItemWidget/tmpl/resourcesItemWidget.hbs');
		Handlebars.registerPartial('resourcesItemWidget', mediaItemPartial);

		let template = `
			{{> resourcesItemWidget
				wg="resourcesItemWidget"
				ns="ResourcesItemWidget"
			}}
		`;
		let precompiled = new Function('return ' + Handlebars.precompile(template))();
		this.itemTemplate = Handlebars.template(precompiled);
	}

	// Update url after filters change
	updateUrl() {
			let url = new URL(window.location.href);	
			for (let [key, value] of Object.entries(this.params)) {
				if (value === undefined) {
					url.searchParams.delete(key);
				} else {
					url.searchParams.set(key, this.params[key]);
				}
			}

			window.history.pushState({}, '', url.toString());
	}

	// Sidebar Checkboxes init
	initCheckbox() {
		let $checkboxWg = this.$sidebar.find('.searchFilterCheckboxWidget');

		$checkboxWg.each((i, obj) => {
			var elFilterKey = $(obj).data('filter-key');
			var urlParamValue = this.params[elFilterKey];
	
			$(obj).find(`input[type="checkbox"]`).each((j, checkbox) => {
				if (urlParamValue && urlParamValue.split(',').includes($(checkbox).val())) {
					$(checkbox).prop('checked', true);
				} else {
					$(checkbox).prop('checked', false);
				}
			});

			$(obj).find(`input[type="checkbox"]:checked`).each((j, ckbx) => {
				var checkboxValue = $(ckbx).val().toString();
				_.each(this.$filterTagBtns, (obj) => {
					const filterKeyItem = $(obj).data('filter-key').toString();
					const valueItem = $(obj).data('value').toString();
					if (filterKeyItem === elFilterKey && valueItem === checkboxValue) {
						$(obj).addClass(CLS_MB_ACTIVE);
					}
				});
			});
			new SearchFilterCheckboxWidget(obj, _.debounce(() => {
                this.setCheckboxParam();

                if(!mediaQuery.breakpointMaxWidth(mediaQuery.BREAKPOINTS.MD)) {
                    this.getItems();
                }
            }, 500));
		});
	}

	// Sidebar Checkboxes listener
	setCheckboxParam() {
		const $checkboxWg = this.$sidebar.find('.searchFilterCheckboxWidget');
		const allCbVal = [];
		// Refresh Filter Tag Buttons
		this.$filterTagBtns.removeClass(CLS_MB_ACTIVE);
		$checkboxWg.each((i, obj) => {
			const $el = $(obj);
			const cbVal = [];
			const elFilterKey = $el.data('filter-key');

			$el.find(`input[type="checkbox"]:checked`).each((i, ckbx) => {
				const cbValue = $(ckbx).val().toString();
				cbVal.push(cbValue);

				// Refresh Filter Tag Buttons
				_.each(this.$filterTagBtns, (obj) => {
					const $obj = $(obj);
					const filterKeyItem = $obj.data('filter-key').toString();
					const valueItem = $obj.data('value').toString();
					if(filterKeyItem === elFilterKey && valueItem === cbValue) {
						$obj.addClass(CLS_MB_ACTIVE);
					}
				});
			});

			allCbVal.push({
				name: elFilterKey,
				value: cbVal
			});
		});
		_.each(allCbVal, (obj, i) => {
			if(obj.value.length === 0) {
				this.params[obj.name] = "";
			}
			else {
				this.params[obj.name] = obj.value.join(',');
			}
		});
	}

	setCarouselParam(){
		let allCbVal = [];
		this.$typeSlickSlides.each((i, obj) => {
			const $el = $(obj);
			$el.on('click', () => {
                allCbVal.push({
                    name: this.getFilterCategory,
                    value: $el.data('typeId'),
					typeName: $el.data('typeName')
                });
                _.each(allCbVal, (obj, i) => {
                    this.params[obj.name] = obj.value;
					this.params["typeName"] = obj.typeName;
                });
                this.getItems();
            })
		});
	}

	handleSearchInput() {
		this.$searchInp.on('keyup', (event) => {
			if(event.keyCode === 13) {
				this.params['keyword'] = $(event.currentTarget).val().trim();
				this.getItems(false);
			}
		});
	}

	// Filters toggle button
	handleFilterBtnMb() {
		this.$fltBtnMb.on('click', () => {
			if(this.$sidebar.hasClass(CLS_MB_ACTIVE)) {
				this.$fltBtnMb.removeClass(CLS_MB_ACTIVE);
				this.$sidebar.removeClass(CLS_MB_ACTIVE);
				this.$fltBtnCloseMb.removeClass(CLS_MB_ACTIVE);
			}
			else {
				this.$fltBtnMb.addClass(CLS_MB_ACTIVE);
				this.$sidebar.addClass(CLS_MB_ACTIVE);
				this.$fltBtnCloseMb.addClass(CLS_MB_ACTIVE);
			}
		});

		this.$fltBtnCloseMb.on('click', () => {1
			this.$fltBtnMb.removeClass(CLS_MB_ACTIVE);
			this.$sidebar.removeClass(CLS_MB_ACTIVE);
			this.$fltBtnCloseMb.removeClass(CLS_MB_ACTIVE);
		});

		this.$fltResetBtnMb.on('click', () => {
			this.resetCheckbox();
			this.getItems();
		});

		this.$backBtn.on('click', () => {
			this.resetCheckbox();
			this.getItems();
		});
	}

	// Sidebar filter titles (hover, click)
	handleFilterTitleTagBtns() {
		// New Filter Title Menu Buttons
		this.$filterTitlesList.on('click mouseover', (event) => {
			let $element = $(event.currentTarget);
			let filterKey = $element.data('filter-key');

			this.$filterTitlesList.removeClass(CLS_MB_ACTIVE);
			$element.addClass(CLS_MB_ACTIVE);

			this.$filterItemsList.removeClass(CLS_MB_ACTIVE);
			_.each(this.$filterItemsList, (obj) => {
				let $obj = $(obj);
				let filterKeyItem = $obj.data('filter-key');
				if(filterKeyItem === filterKey) {
					$obj.addClass(CLS_MB_ACTIVE);
				}
			});
		});

		// New Filter Tag Buttons
		this.$filterTagBtns.on('click', (event) => {
			let $element = $(event.currentTarget);
			let filterKey = $element.data('filter-key');
			let value = $element.data('value');
			let $checkboxWg = this.$sidebar.find('.searchFilterCheckboxWidget');

			$checkboxWg.each((i, obj) => {
				let $el = $(obj);

				if($el.data('filter-key') === filterKey) {
					$('input[type=checkbox][value="'+value+'"]', $el).prop('checked', false).trigger('change');
					$element.removeClass(CLS_MB_ACTIVE);
				}
			});
		});
	}

	// Sidebar Checkboxes reset
	resetCheckbox() {
		let $checkboxWg = this.$sidebar.find('.searchFilterCheckboxWidget');
		_.each($checkboxWg, (obj) => {
			let $obj = $(obj);
			let filterKey = $obj.data('filterKey');
			this.params[filterKey]='';
			$obj.find('input[type="checkbox"]').prop('checked', false);
		});
		this.$filterTagBtns.removeClass(CLS_MB_ACTIVE);
		this.updateUrl();
	}
}
